import React from 'react';
import PropTypes from 'prop-types';
// Local Deps
import './Loading.scss';
import gearsImg from '../../images/gears.svg';

const Loading = ({ text }) => (
  <div className="nf-loading">
    <img className="nf-loading__img" src={gearsImg} alt="presentation" />
    <div className="nf-loading__text">{text}</div>
  </div>
);

Loading.propTypes = {
  text: PropTypes.string,
};

Loading.defaultProps = {
  text: '',
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.jsx